const locale ={
    HELP :"돕다",
    PRIVACY:"은둔",
    TERMS:"자귀",
}

export default locale